import { render, staticRenderFns } from "./aRoomDetailHisFee.vue?vue&type=template&id=c1b793f6"
import script from "./aRoomDetailHisFee.vue?vue&type=script&lang=js"
export * from "./aRoomDetailHisFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports